import { render } from "./TimelineAbout.vue?vue&type=template&id=3c1a000f"
import script from "./TimelineAbout.vue?vue&type=script&lang=js"
export * from "./TimelineAbout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__